<div class="dashboard-container">
  <div class="header">
    <div class="user-info-section">
      <div class="user-role-badge" [ngClass]="{'admin': isAdmin, 'hr': isHrManager, 'superuser': isSuperUser}">
        {{ userRole === 'admin' ? 'Admin' : (userRole === 'superuser' ? 'Super User' : 'HR Manager') }}
      </div>
      <span class="user-name" *ngIf="userName">Welcome, {{ userName }}</span>
    </div>
    <h2>HR Dashboard</h2>
    <div class="action-buttons">
      <button *ngIf="canAddHrManager" class="btn btn-danger" (click)="addHrManager()">
        <fa-icon [icon]="faUserPlus"></fa-icon>
        Add HR Manager
      </button>
      <a routerLink="../employees" class="btn btn-info">
        <fa-icon [icon]="faUserTie"></fa-icon>
        New Employee
      </a>
      <a routerLink="../document-tracking" class="btn btn-primary">
        <fa-icon [icon]="faFileAlt"></fa-icon>
        New Document
      </a>
      <a routerLink="../personal-tracking" class="btn btn-success">
        <fa-icon [icon]="faCalendarPlus"></fa-icon>
        New Personal Event
      </a>
    </div>
  </div>

  <div class="row">
    <!-- Document Summary Stats -->
    <div class="col-md-6">
      <div class="card stats-card">
        <div class="card-body">
          <h5 class="card-title"><fa-icon [icon]="faChartPie" class="text-primary mr-2"></fa-icon> Document Stats</h5>
          <div class="stats" *ngIf="documentSummary$ | async as summary; else emptyStats">
            <div class="stat-item">
              <span class="stat-label">Total</span>
              <span class="stat-value">{{ summary.totalDocuments }}</span>
            </div>
            <div class="stat-item valid">
              <span class="stat-label">Valid</span>
              <span class="stat-value">{{ summary.validDocuments }}</span>
            </div>
            <div class="stat-item expiring">
              <span class="stat-label">Expiring</span>
              <span class="stat-value">{{ summary.expiringDocuments }}</span>
            </div>
            <div class="stat-item expired">
              <span class="stat-label">Expired</span>
              <span class="stat-value">{{ summary.expiredDocuments }}</span>
            </div>
            <div class="stat-item missing">
              <span class="stat-label">Missing</span>
              <span class="stat-value">{{ summary.missingDocuments }}</span>
            </div>
          </div>
          <ng-template #emptyStats>
            <div class="empty-state">
              <fa-icon [icon]="faChartPie" class="empty-state-icon"></fa-icon>
              <p>No document statistics available</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Document Chart -->
    <div class="col-md-6">
      <div class="card chart-card">
        <div class="card-body">
          <h5 class="card-title"><fa-icon [icon]="faChartBar" class="text-primary mr-2"></fa-icon> Document Status</h5>
          <div class="chart-container" *ngIf="documentSummary$ | async as summary; else emptyChart">
            <!-- Comment out chart while we ensure proper module imports -->
            <!-- <canvas baseChart
              [data]="documentChartData"
              [type]="'doughnut'"
              [options]="chartOptions">
            </canvas> -->
            <div class="chart-placeholder">
              <div class="pie-chart" 
                   [style.--valid-size]="getSegmentSize('valid')"
                   [style.--expiring-size]="getSegmentSize('expiring')"
                   [style.--expired-size]="getSegmentSize('expired')"
                   [style.--missing-size]="getSegmentSize('missing')">
              </div>
              <div class="chart-legend">
                <div class="legend-item">
                  <span class="legend-color valid"></span>
                  <span class="legend-label">Valid</span>
                </div>
                <div class="legend-item">
                  <span class="legend-color expiring"></span>
                  <span class="legend-label">Expiring</span>
                </div>
                <div class="legend-item">
                  <span class="legend-color expired"></span>
                  <span class="legend-label">Expired</span>
                </div>
                <div class="legend-item">
                  <span class="legend-color missing"></span>
                  <span class="legend-label">Missing</span>
                </div>
              </div>
            </div>
          </div>
          <ng-template #emptyChart>
            <div class="empty-state">
              <fa-icon [icon]="faChartBar" class="empty-state-icon"></fa-icon>
              <p>No chart data available</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Quick Stats -->
    <div class="col-md-4" *ngIf="false">
      <div class="card quick-stats-card">
        <div class="card-body">
          <h5 class="card-title"><fa-icon [icon]="faInfoCircle" class="text-primary mr-2"></fa-icon> Quick Stats</h5>
          <ng-container *ngIf="hasQuickStats$ | async; else emptyQuickStats">
            <div class="quick-stats">
              <ng-container *ngIf="documentSummary$ | async as summary">
                <div class="quick-stat" *ngIf="summary.expiringDocuments > 0">
                  <div class="icon-circle expiring">
                    <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                  </div>
                  <div class="stat-content">
                    <div class="stat-title">Expiring Documents</div>
                    <div class="stat-value">{{ summary.expiringDocuments }}</div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="upcomingBirthdays$ | async as birthdays">
                <div class="quick-stat" *ngIf="birthdays.length > 0">
                  <div class="icon-circle birthday">
                    <fa-icon [icon]="faBirthdayCake"></fa-icon>
                  </div>
                  <div class="stat-content">
                    <div class="stat-title">Upcoming Birthdays</div>
                    <div class="stat-value">{{ birthdays.length }}</div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="upcomingAnniversaries$ | async as anniversaries">
                <div class="quick-stat" *ngIf="anniversaries.length > 0">
                  <div class="icon-circle anniversary">
                    <fa-icon [icon]="faAward"></fa-icon>
                  </div>
                  <div class="stat-content">
                    <div class="stat-title">Upcoming Anniversaries</div>
                    <div class="stat-value">{{ anniversaries.length }}</div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-template #emptyQuickStats>
            <div class="empty-state">
              <fa-icon [icon]="faInfoCircle" class="empty-state-icon"></fa-icon>
              <p>No quick stats available</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Document Expirations -->
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0"><fa-icon [icon]="faFileAlt" class="text-primary mr-2"></fa-icon> Documents Expiring Soon</h5>
        </div>
        <div class="card-body">
          <ng-container *ngIf="expiringDocuments$ | async as expiringDocs">
            <div class="table-responsive" *ngIf="expiringDocs.length > 0; else emptyExpiringDocs">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Document</th>
                    <th>Employee</th>
                    <th>Expiry Date</th>
                    <th>Remaining</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let doc of expiringDocs">
                    <td>{{ doc.title }}</td>
                    <td>{{ getEmployeeName(doc.employeeId) | async }}</td>
                    <td>{{ formatDate(doc.expiryDate) }}</td>
                    <td>
                      <span [ngClass]="getDaysUntilClass(doc.expiryDate)">
                        {{ getDaysUntilText(doc.expiryDate) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
          <ng-template #emptyExpiringDocs>
            <div class="empty-state">
              <fa-icon [icon]="faFileAlt" class="empty-state-icon"></fa-icon>
              <p>No documents expiring soon</p>
            </div>
          </ng-template>
          <div class="text-right mt-3">
            <a routerLink="../document-tracking" class="btn btn-sm btn-outline-primary view-all-btn">
              <span>View All Documents</span>
              <fa-icon [icon]="faArrowRight"></fa-icon>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Personal Events Summary -->
    <div class="col-md-6" *ngIf="false">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0"><fa-icon [icon]="faCalendarAlt" class="text-primary mr-2"></fa-icon> Upcoming Personal Events</h5>
        </div>
        <div class="card-body">
          <!-- Birthdays -->
          <h6 class="mb-3"><fa-icon [icon]="faBirthdayCake" class="text-danger"></fa-icon> Upcoming Birthdays</h6>
          <ng-container *ngIf="upcomingBirthdays$ | async as birthdays">
            <div class="table-responsive birthdays-section" *ngIf="birthdays.length > 0; else emptyBirthdays">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th>Date</th>
                    <th>Remaining</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let event of birthdays">
                    <td>{{ event.employee.name }}</td>
                    <td>{{ formatDate(event.date) }}</td>
                    <td>
                      <span [ngClass]="getDaysUntilClass(event.date)">
                        {{ getDaysUntilText(event.date) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #emptyBirthdays>
              <div class="empty-state birthdays-empty">
                <fa-icon [icon]="faBirthdayCake" class="empty-state-icon"></fa-icon>
                <p>No upcoming birthdays</p>
              </div>
            </ng-template>
          </ng-container>

          <!-- Anniversaries -->
          <h6 class="mb-3 mt-4"><fa-icon [icon]="faAward" class="text-success"></fa-icon> Upcoming Work Anniversaries</h6>
          <ng-container *ngIf="upcomingAnniversaries$ | async as anniversaries">
            <div class="table-responsive anniversaries-section" *ngIf="anniversaries.length > 0; else emptyAnniversaries">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th>Date</th>
                    <th>Remaining</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let event of anniversaries">
                    <td>{{ event.employee.name }}</td>
                    <td>{{ formatDate(event.date) }}</td>
                    <td>
                      <span [ngClass]="getDaysUntilClass(event.date)">
                        {{ getDaysUntilText(event.date) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #emptyAnniversaries>
              <div class="empty-state anniversaries-empty">
                <fa-icon [icon]="faAward" class="empty-state-icon"></fa-icon>
                <p>No upcoming work anniversaries</p>
              </div>
            </ng-template>
          </ng-container>

          <div class="text-right mt-3">
            <a routerLink="../personal-tracking" class="btn btn-sm btn-outline-primary view-all-btn">
              <span>View All Events</span>
              <fa-icon [icon]="faArrowRight"></fa-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
